module.exports = "<p>\n  user-dashboard works!\n</p>\n"